<div fxLayout="column" fxLayoutGap="20px">
  <!-- Header Card -->
  <mat-card>
    <mat-card-content>
      <mat-card-title fxLayout="row" fxLayoutAlign="space-between center">
        <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
          <span>{{ data?.name }}</span>
          <button mat-icon-button color="warn" matTooltip="Delete accessory bundle" (click)="delete()">
            <mat-icon>delete</mat-icon>
          </button>
        </div>
        <div fxLayout="row" fxLayoutGap="10px">
          <button mat-button (click)="cancel()" [disabled]="!isModified">
            <mat-icon>undo</mat-icon>
            Reset
          </button>
          <button mat-raised-button color="primary" [disabled]="!canSave()" (click)="save()">
            <mat-icon>save</mat-icon>
            Save Changes
          </button>
        </div>
      </mat-card-title>
    </mat-card-content>
  </mat-card>

  <!-- Bundle Details Card -->
  <mat-card>
    <mat-card-content>
      <mat-card-title>Bundle Details</mat-card-title>
      <div fxLayout="row wrap" fxFlexAlign="center" class="row m-t-20">
        <mat-form-field fxFlex="100" class="p-10" *ngIf="data">
          <mat-label>Bundle Name</mat-label>
          <input matInput [(ngModel)]="data.name" (ngModelChange)="checkIfModified()" placeholder="Enter bundle name" required>
          <mat-hint>A descriptive name for this accessory bundle</mat-hint>
        </mat-form-field>

        <mat-form-field fxFlex="100" class="p-10" *ngIf="data">
          <mat-label>Building Instructions</mat-label>
          <input matInput [(ngModel)]="data.buildingInstructions" (ngModelChange)="checkIfModified()" 
                 placeholder="Enter building instructions (optional)">
          <mat-hint>Instructions for how to assemble or use this bundle</mat-hint>
        </mat-form-field>

        <div fxFlex="100" class="p-10 metadata" fxLayout="row" fxLayoutGap="20px">
          <div *ngIf="data?.id"><strong>ID:</strong> {{ data.id }}</div>
          <div *ngIf="data?.dateCreated"><strong>Created:</strong> {{ data.dateCreated | date:'medium' }}</div>
        </div>
      </div>
    </mat-card-content>
  </mat-card>

  <!-- Bundle Items Section -->
  <div fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="20px">
    <!-- Selected Items (Left) -->
    <div fxFlex="50" fxFlex.lt-md="100">
      <mat-card class="h-100">
        <mat-card-content class="h-100" id="selectedContainer" 
                         cdkDropList [cdkDropListData]="selectedItems" 
                         (cdkDropListDropped)="drop($event)">
          <mat-card [class.banner-incomplete]="!isModified" 
                    [class.banner-warning]="isModified">
            <mat-card-content>
              <div fxLayout="row" fxLayoutAlign="space-between center">
                <strong>Accessories ({{ selectedItems.length }})</strong>
                <mat-icon *ngIf="selectedItems.length > 0" matTooltip="Drag to reorder">swap_vert</mat-icon>
              </div>
            </mat-card-content>
          </mat-card>

          <div *ngIf="selectedItems.length === 0" class="empty-state m-t-20" fxLayout="column" fxLayoutAlign="center center">
            <mat-icon class="empty-icon">inbox</mat-icon>
            <p class="text-muted">Drag accessory files here to add them to the bundle</p>
          </div>

          <div *ngFor="let item of selectedItems; let i = index" class="m-t-10">
            <mat-card class="bundle-item-card" cdkDrag>
              <mat-card-content>
                <div fxLayout="row" fxLayoutAlign="space-between center">
                  <div fxLayout="column" fxFlex>
                    <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
                      <mat-icon class="drag-handle" cdkDragHandle>drag_indicator</mat-icon>
                      <strong>Accessory {{ i + 1 }}</strong>
                    </div>
                    <div class="item-details m-t-5">
                      <div><small><strong>Home:</strong> {{ item.code }}</small></div>
                      <div><small><strong>IFC File:</strong> {{ item.homeIfcFileName }}</small></div>
                    </div>
                  </div>
                  <button mat-icon-button color="warn" (click)="onRemoveItem(i)" matTooltip="Remove">
                    <mat-icon>clear</mat-icon>
                  </button>
                </div>
              </mat-card-content>
            </mat-card>
          </div>
        </mat-card-content>
      </mat-card>
    </div>

    <!-- Available IFC Files (Right) -->
    <div fxFlex="50" fxFlex.lt-md="100">
      <mat-card class="h-100">
        <mat-card-content>
          <mat-card class="banner-info">
            <mat-card-content>
              <div fxLayout="row" fxLayoutAlign="space-between center">
                <strong>Available Accessory Files</strong>
              </div>
            </mat-card-content>
          </mat-card>

          <mat-card class="contrast m-t-10">
            <mat-card-content>
              <mat-form-field fxFlex>
                <mat-label>Search Accessory Files</mat-label>
                <input matInput [formControl]="searchControl" placeholder="Search by name or code">
                <mat-icon matSuffix>search</mat-icon>
                <button mat-icon-button matSuffix *ngIf="searchControl.value" 
                        (click)="searchControl.setValue(''); filterIfcFiles('')">
                  <mat-icon>clear</mat-icon>
                </button>
              </mat-form-field>
            </mat-card-content>
          </mat-card>

          <div class="available-files-container" id="availableContainer" 
               cdkDropList [cdkDropListData]="filteredIfcFiles" 
               (cdkDropListDropped)="drop($event)" 
               cdkDropListConnectedTo="selectedContainer">
            
            <div *ngIf="filteredIfcFiles.length === 0" class="empty-state m-t-20" 
                 fxLayout="column" fxLayoutAlign="center center">
              <mat-icon class="empty-icon">search_off</mat-icon>
              <p class="text-muted">No accessory files found</p>
            </div>

            <div *ngFor="let file of filteredIfcFiles" class="m-t-10">
              <mat-card class="ifc-file-card" cdkDrag [cdkDragDisabled]="isItemSelected(file.id)">
                <mat-card-content [class.disabled]="isItemSelected(file.id)">
                  <div fxLayout="row" fxLayoutAlign="space-between center">
                    <div fxLayout="column" fxFlex>
                      <strong>{{ file.name }}</strong>
                      <div class="file-details m-t-5">
                        <div><small><strong>Home:</strong> {{ file.code || 'N/A' }}</small></div>
                        <div *ngIf="file.dateUpdated"><small><strong>Updated:</strong> {{ file.dateUpdated | date:'short' }}</small></div>
                      </div>
                    </div>
                    <mat-icon *ngIf="!isItemSelected(file.id)" class="drag-icon" matTooltip="Drag to add">
                      add_circle_outline
                    </mat-icon>
                    <mat-icon *ngIf="isItemSelected(file.id)" color="accent" matTooltip="Already selected">
                      check_circle
                    </mat-icon>
                  </div>
                </mat-card-content>
              </mat-card>
            </div>
          </div>
        </mat-card-content>
      </mat-card>
    </div>
  </div>
</div>